import { useEffect } from 'react';
import './App.css';
import './i18n';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';

import { AuthProvider } from './lib/auth';
import { CartProvider } from './lib/cart';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';

import Home from './pages/Home';
import About from './pages/About';
import Activities from './pages/Activities';
import Products from './pages/Products';
import Impact from './pages/Impact';
import Formation from './pages/Formation';
import Gallery from './pages/Gallery';
import News from './pages/News';
import Visit from './pages/Visit';
import Partners from './pages/Partners';
import Support from './pages/Support';
import Experiences from './pages/Experiences';
import Shop from './pages/Shop';
import ShopSuccess from './pages/ShopSuccess';
import Sponsorship from './pages/Sponsorship';
import SponsorshipSuccess from './pages/SponsorshipSuccess';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  return (
    <>
      <Header />
      {children}
      <CartDrawer />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/" element={<PublicShell><Home /></PublicShell>} />
              <Route path="/about" element={<PublicShell><About /></PublicShell>} />
              <Route path="/activities" element={<PublicShell><Activities /></PublicShell>} />
              <Route path="/products" element={<Navigate to="/shop" replace />} />
              <Route path="/impact" element={<PublicShell><Impact /></PublicShell>} />
              <Route path="/formations" element={<PublicShell><Formation /></PublicShell>} />
              <Route path="/gallery" element={<PublicShell><Gallery /></PublicShell>} />
              <Route path="/news" element={<PublicShell><News /></PublicShell>} />
              <Route path="/visit" element={<PublicShell><Visit /></PublicShell>} />
              <Route path="/partners" element={<PublicShell><Partners /></PublicShell>} />
              <Route path="/support" element={<PublicShell><Support /></PublicShell>} />
              <Route path="/experiences" element={<PublicShell><Experiences /></PublicShell>} />
              <Route path="/shop" element={<PublicShell><Shop /></PublicShell>} />
              <Route path="/shop/success" element={<PublicShell><ShopSuccess /></PublicShell>} />
              <Route path="/sponsorship" element={<PublicShell><Sponsorship /></PublicShell>} />
              <Route path="/sponsorship/success" element={<PublicShell><SponsorshipSuccess /></PublicShell>} />
              <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
            </Routes>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
